import * as React from 'react';
import './inputCheck.css';
import { GetGuid } from '../lib';

interface IInputCheckProps {
    id?: string;
    ckecked?: boolean;
    label: string;
    width?: string;
    height?: string;
    OnChecked?: (value: boolean, id?: string) => void;
}

class InputCheck extends React.Component<IInputCheckProps> {
    constructor(props: IInputCheckProps) {
        super(props);
    }

    OnClickCheckedOn = (event: React.MouseEvent<HTMLDivElement>) => {
        if (this.props.OnChecked !== undefined) {
            let id: string = this.props.id !== undefined ? this.props.id : GetGuid();
            this.props.OnChecked(true, id);
        }
    };
    OnClickCheckedOff = (event: React.MouseEvent<HTMLDivElement>) => {
        if (this.props.OnChecked !== undefined) {
            let id: string = this.props.id !== undefined ? this.props.id : GetGuid();
            this.props.OnChecked(false, id);
        }
    };

    render() {
        let width: string = this.props.width !== undefined ? this.props.width : '100%';
        let height: string = this.props.height !== undefined ? this.props.height : '20px';
        let ckecked: boolean = this.props.ckecked !== undefined ? this.props.ckecked : false;

        let sty = {
            width: width,
            height: height
        };

        let CheckBoxView = ckecked ? (
            <div className="inputCheck_def_checkbox" style={sty}>
                <div onClick={this.OnClickCheckedOff} id={this.props.id}>
                    <svg
                        className="inputCheck_def_input"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <rect
                            x="0.1"
                            y="0.1"
                            width="11.8"
                            height="11.8"
                            fill="#E4F4F7"
                            stroke="#66C3D0"
                            strokeWidth="0.2"
                        />
                        <path
                            d="M8.39959 0.429971C6.89263 2.89964 5.31526 5.32212 3.68155 7.69741C2.9492 6.98954 2.20276 6.28167 1.47041 5.57381C0.653553 4.78729 -0.543561 6.10864 0.273293 6.91089C1.24507 7.85471 2.21684 8.78281 3.2027 9.72663C3.51254 10.0255 4.10406 10.1514 4.39982 9.72663C6.30112 7.021 8.132 4.23672 9.85021 1.38952C10.4699 0.36705 9.00519 -0.576773 8.39959 0.429971Z"
                            fill="#66C3D0"
                        />
                    </svg>
                </div>
                <div className="inputCheck_def_label">{this.props.label}</div>
            </div>
        ) : (
            <div className="inputCheck_def_checkbox" style={sty}>
                <div onClick={this.OnClickCheckedOn} id={this.props.id}>
                    <svg
                        className="inputCheck_def_input"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <rect
                            x="0.1"
                            y="0.1"
                            width="11.8"
                            height="11.8"
                            fill="white"
                            stroke="#8B8B8B"
                            strokeWidth="0.2"
                        />
                    </svg>
                </div>
                <div className="inputCheck_def_label">{this.props.label}</div>
            </div>
        );

        return <React.Fragment key={this.props.id + this.props.label}>{CheckBoxView}</React.Fragment>;
    }
}

export default InputCheck;
